import {compose} from './../../fp.helper';
import {IntroContent, NormalizedIntroContent} from './intro.types';

const addSelectedProp = (contents: IntroContent[]): NormalizedIntroContent[] => {
	return contents.map((content) => {
		return {...content, selected: false};
	});
};

const setInitialSelectedToTrue = (normalizedContent: NormalizedIntroContent[]): NormalizedIntroContent[] => {
	normalizedContent[0].selected = true;
	return normalizedContent;
};

export const normalizeContent = compose(setInitialSelectedToTrue, addSelectedProp);
